import type { ReactNode, SVGProps } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

export function SvgPhoneVerification({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): ReactNode {
  return (
    <svg
      aria-labelledby={titleId}
      fill="none"
      height={80}
      viewBox="0 0 80 80"
      width={80}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M14 23.242v21.064c0 .295.147.539.359.685l1.148.666c.242.136.55.154.825-.005l26.19-15.154a.83.83 0 0 0 .415-.721V8.732a.83.83 0 0 0-.41-.717l-1.111-.642a.82.82 0 0 0-.81.013l-26.19 15.135a.83.83 0 0 0-.416.721"
        fill="#1A1A1A"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.8}
      />
      <path
        d="M15.227 44.726V24.05a1 1 0 0 1 .5-.866L41.58 8.24a1 1 0 0 1 1.5.866v20.659a1 1 0 0 1-.498.865L16.726 45.59a1 1 0 0 1-1.5-.865"
        fill="#FFC9A6"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.8}
      />
      <path
        d="m32.514 22.7 6.823-4.06m-6.823 8.595 6.823-4.06"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.8}
      />
      <path
        d="M24.189 30.057c-3.112 1.851-5.634 6.532-5.634 10.454l11.268-6.704c0-3.922-2.523-5.601-5.634-3.75"
        fill="#fff"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.8}
      />
      <circle
        cx={3.278}
        cy={3.278}
        fill="#fff"
        r={3.278}
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeWidth={0.8}
        transform="matrix(.8594 -.5113 0 1 21.361 25.152)"
      />
      <path
        d="M39.25 17.25c.347-.6.83-1.113 1.41-1.497L62.122 3.377c.77-.43 1.51-.493 2.088-.184a1.76 1.76 0 0 1 .853 1.48l.016 55.6a4.53 4.53 0 0 1-2.05 3.809l-21.49 12.37a2.24 2.24 0 0 1-2.102-.105 1.64 1.64 0 0 1-.568-.614 1.66 1.66 0 0 1-.205-.82L38.63 19.49c.006-.788.22-1.56.62-2.24Z"
        fill="#D5C8FF"
        stroke="#1A1A1A"
        strokeLinejoin="round"
        strokeWidth={0.8}
      />
      <path
        d="M40.89 20.164c0-1.105.776-2.448 1.733-3L63.239 5.26c.957-.553 1.732-.105 1.732 1v54.698c0 1.104-.775 2.447-1.732 3L42.623 75.862c-.957.552-1.732.104-1.732-1z"
        fill="#fff"
        stroke="#1A1A1A"
        strokeLinejoin="round"
        strokeWidth={0.8}
      />
      <path
        d="M53.73 58.456c1.624-.938 2.941-.178 2.941 1.698s-1.317 4.157-2.941 5.095c-1.625.937-2.942.177-2.942-1.699 0-1.875 1.317-4.156 2.942-5.094Z"
        fill="#D5C8FF"
        stroke="#1A1A1A"
        strokeLinejoin="round"
        strokeWidth={0.8}
      />
      <path
        d="M0 0h13.999v13.999H0z"
        stroke="#1A1A1A"
        strokeLinejoin="round"
        strokeWidth={0.8}
        transform="matrix(.86601 -.50003 -.00003 1 48.082 35.274)"
      />
      <path
        d="M54.143 31.774v1.5m6.06 1.999-1.299.75m-4.759 8.25v1.5m-4.765-4.25-1.298.75"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeWidth={0.8}
      />
    </svg>
  );
}
